import React, { createContext, useContext } from 'react';

// SECURITY/UX: A single React context that exposes the language map fetched
// from /api/language to *every* component, including ones that historically
// were not threaded a `lang` prop (Profile, Training, AvatarCropper, …).
// Keeps backwards-compat: components that receive `lang` via props can keep
// doing so; components without props can call `useLang()` to access the same
// dictionary.

const LangContext = createContext({});

export const LangProvider = ({ value, children }) => (
  <LangContext.Provider value={value || {}}>{children}</LangContext.Provider>
);

export const useLang = () => useContext(LangContext) || {};

export default LangContext;
